<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-default(:to="{name: 'setCodeStatusFileUpload'}") Upload File
    form.panel.panel-default.form-horizontal(role="form" @submit.prevent="setCodeStatus()")
        .panel-heading.panel-title Codes
        .panel-body
          .row
            .col-sm-12
              textarea.code-statuses.form-control(v-model="codes" placeholder="Codes")
        .panel-footer
          .text-right
            span.checkbox-text
              span Fail on invalid codes
            span.checkbox-parent
              input.invalid-codes-checkbox(type="checkbox" v-model="ignoreInvalidCodes")
            button.btn.btn-primary(type="submit" :disabled="!isValid") Set Status
    GenericTable
      tr(slot="thead")
        th Id
        th Description
        th
      tr(v-for="ct in codeStatus")
        td {{ct.id}}
        td {{ct.description}}
        td
          input.form-control(type="checkbox" :value="ct.id" v-model="checkedStatuses")
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import GenericTable from '@/components/common/GenericTable'
import Util from '@/service/Util'

export default {
  data: () => ({
    codeStatus: null,
    codes: null,
    file: null,
    ignoreInvalidCodes: false,
    ignoreInvalidFileCodes: false,
    checkedStatuses: [],
    errorMsg: null,
    fileError: null
  }),
  created() {
    this.fetchData()
  },
  methods: {
    setCodeStatus() {
      const req = {}
      req.codes = Util.sanitizeCodes(this.codes)
      req.statuses = this.checkedStatuses
      req.ignoreInvalidCodes = this.ignoreInvalidCodes
      Core.setCodeStatus(req)
        .then(() => {
          miniToastr.success('Code status set')
          this.codes = null
          this.checkedStatuses = []
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    fetchData() {
      Core.listCodeStatuses()
        .then((resp) => {
          this.codeStatus = resp.data.codeStatusField.filter((c) => {
            if (c.settable === true) {
              return c
            }
            return null
          })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  computed: {
    isValid() {
      return this.codes && this.checkedStatuses.length > 0
    }
  },
  components: {
    GenericTable
  }
}
</script>

<style lang="scss">
.code-statuses {
  min-height: 100px;
  max-width: 100%;
}
.checkbox-text {
  margin-right: 10px;
}

.checkbox-parent {
  margin-right: 10px;
}

.invalid-codes-checkbox {
  width: 33px;
  height: 33px;
}

.file-uploader {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/SetCodeStatus.vue